/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useState,
  useMemo,
  useContext,
  useCallback,
  useRef,
} from "react";
import Screen from "../../components/Screen";
import { IDBack, IDFront, Selfie } from "../../components/Icons";
import {
  Form,
  Button,
  Col,
  Row,
  Container,
  InputGroup,
  Modal,
} from "react-bootstrap";
import {
  isDate,
  invertDate,
  formatDate,
  calculateAge,
  dataURLtoBlob,
  getMonth,
  getYear,
  range,
  resizeImage
} from "../../functions";
import { getCDNImage } from "../../globals";
import InputMask from "react-input-mask";
import { usePersistentState } from "../../hooks/usePersistentState";
import { T } from "react-translator-component";
import { useNavigate, useParams, Link } from "react-router-dom";
import { CheckInContext } from "../../context/checkin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCamera, faFileUpload, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import CameraCropper from "../../components/CameraCropper";
import { Storage } from "aws-amplify";
import * as Yup from "yup";
import { UserContext } from "../../context/user";
import { HotelContext } from "../../context/hotel";
import { getCountriesList } from "../../configs/getCountriesList";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import de from "date-fns/locale/de";
import { parseISO } from "date-fns";
// import isApartYou from "../../components/CheckIn/isApartYou";

import { isCostaGalana, isApartYou, isHostz, isOffgrid, isKalmStay, isBelAir, isHostzSwissstay, isHostzArosa, isSimplex, isHostzMyde, isDemo, isRoyal, isAlvarezArguellez, isHostzSigma, isBlackSummit } from "../../components/CheckIn/hotelConditions";

import RequiredIcon from "../../components/CheckIn/RequiredIcon";
import { ErrorMessages } from "../../components/ErrorMessages";
import { buildYupSchema } from '../../helpers/YupSchemaBuilder.js';
import { kalmstayFieldsConfig } from './kalmstay.config.js';
import { blackSummitCompanionFieldsConfig } from './blacksummit.config.js';
import { useKiosk } from "../../hooks/useKiosk";
import { normalizePassengerGender } from "../../helpers/normalizePassengerGender";
import '../CheckInDetailNew.css';

registerLocale("es", es);
registerLocale("de", de);

const CheckInPassenger = () => {
  const { isKioskMode } = useKiosk();
  const { language } = useContext(UserContext);
  const currentLanguage = language?.slice(0, 2) || "en";
  const navigate = useNavigate();
  const { linked_checkin_idx, idx } = useParams();
  const {
    data: checkIn,
    setPassengerData,
    setPassengerLinkedCheckinData,
    addPassengersPhotosEventsCallback,
  } = useContext(CheckInContext);
  const [dniInformationColumnWidth, setDniInformationColumnWidth] = useState(4);
  const [genderColumnWidth, setGenderColumnWidth] = useState(12);  

  let passengers = checkIn.passengers || [];
  if (linked_checkin_idx !== undefined) {
    passengers = checkIn.linked_checkins?.[linked_checkin_idx]?.passengers || [];
  }

  const _prefix_storage = `checkIn-passenger-${checkIn.timestamp ?? "0"}${linked_checkin_idx !== undefined ? `-${linked_checkin_idx}` : ""}-${idx}`;

  const { data: hotel } = useContext(HotelContext);
  // const [values, setValues] = useState(null)
  const [values, setValues] = usePersistentState(
    _prefix_storage,
    null
  );
  const sortedCountries = getCountriesList(currentLanguage, hotel.id);


  const [cameraMode, setCameraMode] = useState(null);
  const [photoSelfie, setPhotoSelfie] = usePersistentState(
    `${_prefix_storage}-photo-selfie`,
    { uploading: false, value: passengers[idx]?.photos?.selfie }
  );
  const [photoDniFront, setPhotoDniFront] = usePersistentState(
    `${_prefix_storage}-photo-dniFront`,
    { uploading: false, value: passengers[idx]?.photos?.dniFront }
  );
  const [photoDniBack, setPhotoDniBack] = usePersistentState(
    `${_prefix_storage}-photo-dniBack`,
    { uploading: false, value: passengers[idx]?.photos?.dniBack }
  );
  const setterMode = {
    selfie: setPhotoSelfie,
    dniFront: setPhotoDniFront,
    dniBack: setPhotoDniBack,
  };

  const [imageFromDevice, setImageFromDevice] = useState("");
  const [imageOriginModal, setImageOriginModal] = useState(["", ""]);

  /** Acompañante de Black Summit: solo nombre, apellido, fecha de nacimiento y nacionalidad. */
  const isBlackSummitCompanion = useMemo(
    () => isBlackSummit(hotel.id) && parseInt(idx, 10) > 0,
    [hotel.id, idx]
  );

  const isForeing = () => {
    if (isSimplex(hotel.id)) {
      console.log('isForeing value nac', values?.nationality)
      console.log('isForeing', values?.nationality?.toLowerCase() != "de")
      return values?.nationality?.toLowerCase() != "de"
    }
    return true
  }

  const getCheckInPersonSchemaArosa = (isIdFrontRequired) =>

    // Nombre y Apellidos
    // Fecha de nacimiento
    // Nacionalidad
    // Número de Identificación: (entiendo que esto es Tipo de Documento y numero vdd ?) 
    // Dirección
    // Correo electrónico
    // Foto del frente del Doc

    Yup.object().shape({
      name: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      surname: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      birthday: Yup.date()
        .nullable()
        .max(new Date(), "yup.wrong-date")
        .typeError("-")
        .required("yup.required"),
      nationality: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters"),
      dni: Yup.string()
        .nullable()
        .min(6, "yup.minimal-6-digits")
        .max(12, "yup.maximal-12-digits")
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => true,
          then: Yup.string().matches(/^[0-9a-zA-Z]+$/, "yup.only-numbers-and-letters").required("yup.required").nullable(),
          otherwise: Yup.string().nullable().matches(/^[0-9a-zA-Z]+$/, "yup.only-numbers-and-letters"),
        })
        .when("dniType", {
          is: (value) =>
            value === "DNI" ||
            value === "PASSPORT" ||
            value === "NIF" ||
            value === "CIF",
          then: Yup.string().nullable().matches(
            /^[0-9a-zA-Z]+$/,
            "yup.only-numbers-and-letters"
          ),
        }),
      dniType: Yup.string()
        .required("yup.required")
        .nullable()
        .min(2, "yup.minimal-2-digits")
        .max(12, "yup.maximal-12-digits"),
      address: Yup.string()
        .required("yup.required").nullable(),
      email: Yup.string()
        .nullable()
        .when(["$idx"], {
          is: (idx) => (idx > 0),
          then:
            Yup.string().email("yup.email-invalid-format").required('yup.required')
        }),
      photos: Yup.object().shape({
        selfie: Yup.string().nullable(),
        dniFront: Yup.string().required("yup.required").nullable(),
        dniBack: Yup.string().nullable()
      }),
    });
  const getCheckInPersonSchemaSimplex = (isIdFrontRequired) =>

    // Nombre y Apellidos
    // Fecha de nacimiento
    // Nacionalidad
    // Número de Identificación: (entiendo que esto es Tipo de Documento y numero vdd ?) 
    // Dirección
    // Correo electrónico
    // Foto del frente del Doc

    Yup.object().shape({
      name: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      surname: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      birthday: Yup.date()
        .nullable()
        .max(new Date(), "yup.wrong-date")
        .typeError("-")
        .required("yup.required"),
      nationality: Yup.string()
        .nullable()
        .required("yup.required")
        .min(2, "yup.minimal-2-letters"),
      dni: Yup.string()
        .nullable()
        .when(["$hotelId", "$idx"], {
          is: () => {
            return isForeing()
          },
          then: Yup.string().matches(/^[0-9a-zA-Z]+$/, "yup.only-numbers-and-letters")
            .required("yup.required")
            .min(6, "yup.minimal-6-digits")
            .max(12, "yup.maximal-12-digits")
            .nullable()
        })
        .when("dniType", {
          is: (value) => {
            return (
              value === "DNI" ||
              value === "PASSPORT" ||
              value === "NIF" ||
              value === "CIF")
          },
          then: Yup.string().matches(
            /^[0-9a-zA-Z]+$/,
            "yup.only-numbers-and-letters"
          ).nullable()
        }),
      dniType: Yup.string().nullable()
        .when(["$hotelId", "$idx"], {
          is: () => isForeing(),
          then: Yup.string().required("yup.required")
            .min(2, "yup.minimal-2-digits")
            .max(12, "yup.maximal-12-digits")
            .nullable()
        }),
      address: Yup.string()
        .nullable()
        .required("yup.required"),
      email: Yup.string()
        .nullable()
        .when(["$idx"], {
          is: (idx) => (idx > 0),
          then:
            Yup.string()
              .email("yup.email-invalid-format")
              .required('yup.required')
              .nullable()
        }),
      photos: Yup.object().shape({
        selfie: Yup.string().nullable(),
        dniFront: Yup.string()
          .nullable()
          .when(["$hotelId", "$idx"], {
            is: () => isForeing(),
            then: Yup.string()
              .required("yup.required")
              .nullable()
          }),
        dniBack: Yup.string().nullable()
      }),
    });

  const getCheckInPersonSchema = (isIdFrontRequired) =>
    Yup.object().shape({
      name: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      dni: Yup.string()
        .nullable()
        .min(6, "yup.minimal-6-digits")
        .max(12, "yup.maximal-12-digits")
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0),
          then: Yup.string().matches(/^[0-9a-zA-Z]+$/, "yup.only-numbers-and-letters").required("yup.required").nullable(),
          otherwise: Yup.string().nullable().matches(/^[0-9a-zA-Z]+$/, "yup.only-numbers-and-letters"),
        })
        .when("dniType", {
          is: (value) =>
            value === "DNI" ||
            value === "PASSPORT" ||
            value === "NIF" ||
            value === "CIF",
          then: Yup.string().nullable().matches(
            /^[0-9a-zA-Z]+$/,
            "yup.only-numbers-and-letters"
          ),
        }),
      dniType: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-digits")
        .max(12, "yup.maximal-12-digits")
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      // dniIssueDate: Yup.date()
      //   .nullable()
      //   .max(new Date(), "yup.wrong-date")
      //   .typeError("-")
      //   .when(["$hotelId", "$idx"], {
      //     is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0) && hotelId !== "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b" && hotelId !== "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11" && hotelId !== "1de880e5-bfb6-4518-bd1b-095443bbc58b" && hotelId !== "8b91c3ba-6ef0-4667-805b-30b51f378ca5" && !isHostz(hotelId) && !isBelAir(hotelId),
      //     then: Yup.date().required("yup.required").nullable(),
      //     otherwise: Yup.date().nullable(),
      //   }),
      dniIssueDate: Yup.date()
        .nullable()
        .typeError("-")
        .when(["$hotelId", "$idx"], (hotelId, idx, schema) => {
          const common = schema.nullable().typeError("-");
          if (isOffgrid(hotelId) || isSimplex(hotelId)) {
            return common.required("yup.required");
          } else {
            if (
              !(isApartYou(hotelId) && idx > 0) &&
              hotelId !== "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b" &&
              !isHostz(hotelId) &&
              !isAlvarezArguellez(hotelId)
            ) {
              return common.required("yup.required").max(new Date(), "yup.wrong-date");
            }
          }

          return common;
        }),
      surname: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .max(50, "yup.maximal-50-letters")
        .required("yup.required"),
      gender: Yup.string()
        .nullable()
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0) &&
            hotelId !== "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b" &&
            hotelId !== "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11" &&
            hotelId !== "f33a83b9-6284-46e6-8469-b5b17de2c9ba" &&
            !isHostz(hotelId) &&
            !isSimplex(hotelId),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      birthday: Yup.date()
        .nullable()
        .max(new Date(), "yup.wrong-date")
        .typeError("-")
        .required("yup.required"),
      nationality: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      photos: Yup.object().shape({
        selfie: Yup.string()
          .nullable()
          .when(["$hotelId", "$idx"], {
            is: (hotelId, idx) => (isHostzMyde(hotelId) || isHostzSigma(hotelId) || isRoyal(hotelId) || isHostzSwissstay(hotelId)) && idx == 0,
            then: Yup.string().required("yup.required").nullable(),
            otherwise: Yup.string().nullable(),
          }),
        dniFront: Yup.string()
          .nullable()
          .when(["$hotelId", "$idx"], {
            is: (hotelId, idx) => isIdFrontRequired && (isAlvarezArguellez(hotelId) || isCostaGalana(hotelId) || 
            isBelAir(hotelId) || 
            isOffgrid(hotelId) || 
            isKalmStay(hotelId) || 
            isSimplex(hotelId) || 
            (isHostz(hotelId) && !isHostzSigma(hotelId) && !isHostzSwissstay(hotelId)) ||
            ((isHostzSigma(hotelId) || isHostzSwissstay(hotelId)) && idx == 0)),
            then: Yup.string().required("yup.required").nullable(),
            otherwise: Yup.string().nullable(),
          }),
        dniBack: Yup.string()
          .nullable()
          .when(["$hotelId", "$idx"], {
            is: (hotelId, idx) => isOffgrid(hotelId) || isHostzMyde(hotelId),
            then: Yup.string().required("yup.required").nullable(),
            otherwise: Yup.string().nullable(),
          })
      }),
      address: Yup.string()
        .nullable()
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => !(isApartYou(hotelId) && idx > 0),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      zipCode: Yup.string()
        .nullable()
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => (!isHostzSwissstay(hotelId) && !(isApartYou(hotelId) && idx > 0)),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      age: Yup.number()
        .max(120, "yup.please-review")
        .min(0, "yup.please-review"),
      residence: Yup.string()
        .nullable()
        .min(2, "yup.minimal-2-letters")
        .when(["$hotelId", "$idx"], {
          is: (hotelId, idx) => (!isHostzSwissstay(hotelId) && !(isApartYou(hotelId) && idx > 0)),
          then: Yup.string().required("yup.required").nullable(),
          otherwise: Yup.string().nullable(),
        }),
      city: Yup.string()
        .nullable()
        .when("$hotelId", {
          is: (hotelId) => {
            return hotelId === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516" //Gemunder
          },
          then: Yup.string().nullable().min(2, "yup.minimal-2-letters").required("yup.required"),
          otherwise: Yup.string().nullable(),
        }),
    });

  const getValidations = (hotelId, isIdFrontRequired) => {
    if (isSimplex(hotelId)) {
      return getCheckInPersonSchemaSimplex(isIdFrontRequired);
    }
    if (isHostzArosa(hotelId)) {
      return getCheckInPersonSchemaArosa(isIdFrontRequired);
    }
    if (isKalmStay(hotelId)) {
      hotel.nationality = 'DE';
      return buildYupSchema(kalmstayFieldsConfig, { hotelId: hotelId, idx: parseInt(idx, 10), hotelNationality: hotel.nationality });
    }
    if (isBlackSummitCompanion) {
      return buildYupSchema(blackSummitCompanionFieldsConfig, { hotelId: hotelId, idx: parseInt(idx, 10) });
    }
    return getCheckInPersonSchema(isIdFrontRequired);

  }


  const isComahue = useMemo(
    () => (
      hotel.id === "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11" ||
      hotel.id === "f33a83b9-6284-46e6-8469-b5b17de2c9ba"
    ),
    [hotel.id]
  );
  const isBrizoNeuquen = useMemo(
    () => (
      hotel.id === "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b" ||
      hotel.id === "f33a83b9-6284-46e6-8469-b5b17de2c9ba"
    ),
    [hotel.id]
  );

  const showDniIssueDate = useMemo(() => {
    return !isComahue && !isBrizoNeuquen && !isCostaGalana(hotel.id) && !isHostz(hotel.id) && !isBelAir(hotel.id) && !isAlvarezArguellez(hotel.id)
  }, [isComahue, isBrizoNeuquen, hotel.id])

  useEffect(() => {
    if (showDniIssueDate) {
      setDniInformationColumnWidth(4);
    } else {
      setDniInformationColumnWidth(6);
    }
  }, [showDniIssueDate, isKioskMode])

  const photoDNIFrontRequired = useMemo(() => {
    return hotel.id === "511e8df9-672d-42b1-9711-d82beb7baf64" ||
      hotel.id === "d4676e50-71ed-4c01-bcdf-84b2b55b1890" ||
      hotel.id === "b2501a57-ef47-445a-99fb-05324a4eb7e6" || // black-summit
      hotel.id === "9983de2a-9f3e-4c75-9fb9-62e9855681e8" ||
      hotel.id === "b58142a6-dfbc-4b7a-ab7e-8bac3e848b51" ||

      hotel.id === "d55fa17e-d630-49ea-af48-4b2d2d9e557c" ||
      hotel.id === "23a7aaa1-f022-477a-abc6-c6f0d0e92dbf" ||
      hotel.id === "49e0c3db-e283-4c50-afc3-f16ab364733c" ||
      hotel.id === "7ef6b919-e25f-4153-9fb3-8e7939ff7252" ||
      hotel.id === "8d03f1be-8796-4a8b-9263-ff9e7b9584eb" ||

      hotel.id === "44dc5e46-b6ca-43c9-8ec7-e4a4b5ebb66b" ||
      hotel.id === "eb618aea-3d7b-4496-986a-b7f034554ac8" ||
      hotel.id === "af8e44a0-c64c-4647-bb12-abd0af4b4a4b" ||
      hotel.id === "b09e49f0-d0ac-4723-ac65-8cce7aba74c8" ||
      hotel.id === "42b8cd5a-0aa8-407b-b9d8-c2f2b7e2b6cc" ||
      hotel.id === "59f21e07-f8a4-46f0-b294-b74f03348a9f"
  }, [hotel.id])

  const showImages = useMemo(() => {
    // Gemunder o pasajeros adicionales de Hostz Sigma o Swissstay no muestran las fotos
    if (hotel.id === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516" || isKioskMode || ((isHostzSigma(hotel.id) || isHostzSwissstay(hotel.id)) && idx > 0)) {
      return false;
    }
    if (isBlackSummitCompanion) {
      return false;
    }
    // if (isKalmStay(hotel.id)) {
    //   if (!values?.nationality) return false;
    //   if (values?.nationality?.toLowerCase() == "de") return false;
    // }

    return true;
  }, [hotel.id, values, isBlackSummitCompanion])
  const showSelfie = useMemo(() => {

    if ((isHostzMyde(hotel.id) || isHostzSigma(hotel.id) || isHostzSwissstay(hotel.id)) && idx == 0) {
      return true;
    }

    if (isHostz(hotel.id) || isSimplex(hotel.id)) {
      console.log('showSelfie false')
      return false;
    }
    return true;
  }, [hotel.id])

  const dniNumber = useMemo(() => {
    if (isOffgrid(hotel?.id)) {
      return T("checkin.inputs.dni-number");
    }
    return T("checkin.inputs.dni-number");
  }, [hotel.id]);

  const dniIssueDate = useMemo(() => {
    if (isOffgrid(hotel?.id)) {
      return T("checkin.inputs.dni-issue-date-offgrid");
    }
    if (isSimplex(hotel?.id)) {
      return T("checkin.inputs.dni-issue-date-simplex");
    }
    return T("checkin.inputs.dni-issue-date");
  }, [hotel.id]);

  const showGender = useMemo(() => {
    if (isSimplex(hotel.id)) return false;
    if (isBlackSummitCompanion) return false;
    if (isHostzArosa(hotel.id)) {
      if (idx > 0) return false;  // Pasajeros adicionales no muestran el genero
    }
    return true;
  }, [hotel.id, isBlackSummitCompanion]);

  useEffect(() => {
    if (showGender) {
      setGenderColumnWidth(12);
    } else {
      setGenderColumnWidth(6);
    }
  }, [showGender])

  const { classZipCode, classRequiredZipCode, classRequiredCountryOfResidency, classAddressCode, classRequiredGender, classDocumentRow, classLocationRow } = useMemo(() => {
    let clsRes = {
      classZipCode: "",
      classRequiredZipCode: "",
      classRequiredCountryOfResidency: "",
      classAddressCode: "",
      classRequiredGender: "",
      classDocumentRow: "",
      classLocationRow: ""
    }
    if (isBlackSummitCompanion) {
      // Acompañante de Black Summit: solo datos personales
      clsRes.classDocumentRow = "form-field-hidden";
      clsRes.classLocationRow = "form-field-hidden";
    }
    if (isHostzArosa(hotel.id)) {
      clsRes.classRequiredZipCode = "form-field-hidden";
      clsRes.classRequiredCountryOfResidency = "form-field-hidden";
      clsRes.classRequiredGender = "form-field-hidden";
      if (idx > 0) {
        // Pasajeros adicionales no muestran el genero
        clsRes.classZipCode = "form-field-hidden";
        clsRes.classAddressCode = "form-field-full-width";
      };
    }
    if (isSimplex(hotel.id)) {
      clsRes.classRequiredZipCode = "form-field-hidden";
      clsRes.classRequiredCountryOfResidency = "form-field-hidden";
      clsRes.classRequiredGender = "form-field-hidden";
      if (idx > 0) {
        // Pasajeros adicionales no muestran el genero
        clsRes.classZipCode = "form-field-hidden";
        clsRes.classAddressCode = "form-field-full-width";
      };
    }
    return clsRes;
  }, [hotel.id, isBlackSummitCompanion]);
  const classEmail = useMemo(() => {
    if (isHostzArosa(hotel.id) || isSimplex(hotel.id)) {
      if (idx > 0) return ""; // Muestro para los pasajeros que no son el 0
    }
    return "form-field-hidden";
  }, [hotel.id]);
  const classRowCity = useMemo(() => {
    if (isBlackSummitCompanion) return "form-field-hidden";
    if (isHostzArosa(hotel.id) || isSimplex(hotel.id)) {
      if (idx > 0) return "form-field-hidden";  // Pasajeros adicionales no muestran el residencia y ciudad
    }
    return "";
  }, [hotel.id, isBlackSummitCompanion]);


  const ImageOriginModal = () => {
    const inputRef = useRef(null);
    const handleClose = () => setImageOriginModal(["", ""]);
    const handleOpenCamera = () => {
      handleClose();
      setCameraMode(imageOriginModal[0]);
    };

    const handleUploadPhotoFromDevice = () => {
      const fileName =
        checkIn.id +
        "_" +
        imageOriginModal[0] +
        "_" +
        idx +
        "_" +
        Date.now() +
        ".jpg";
      const setter = setterMode[imageOriginModal[0]];

      if (setter) {
        setter({ uploading: true, value: null });
        handleClose();
      }

      // Redimensionar la imagen antes de subirla
      resizeImage(imageFromDevice)
        .then((resizedBlob) => {
          return Storage.put(fileName, resizedBlob);
        })
        .then((res) => {
          if (res && res.key !== undefined) {
            if (setter) {
              setter({ uploading: false, value: res.key });
            }
            setImageFromDevice(null);
          }
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
          if (setter) {
            setter({ uploading: false, value: null });
          }
        });
    };

    const isMydeSelfieModal = useMemo(() => {
      return (isHostzMyde(hotel.id) || isHostzSigma(hotel.id) || isRoyal(hotel.id) || isHostzSwissstay(hotel.id)) && imageOriginModal[0] === "selfie" && idx == 0;
    }, [hotel.id, imageOriginModal[0], idx]);

    return (
      <Modal
        show={imageOriginModal[0] !== ""}
        onHide={handleClose}
        className="camera-detail-modal"
      >
        <Modal.Body
          className="text-center"
          style={{
            border: "1px solid #a07e00",
            borderBottom: "none",
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8,
            display: "flex",
            flexDirection: "column", // Cambiar a columna para centrar verticalmente
            alignItems: "center", // Centrar horizontalmente
            justifyContent: "center", // Centrar verticalmente
            height: isMydeSelfieModal ? "300px" : "250px",
            textAlign: "center", // Asegurar que el texto esté centrado
          }}
        >
          {!imageFromDevice ? (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column", // Apilamos en columna
                  alignItems: "center", // Centramos los elementos
                  padding: "15px",
                  position: "relative",
                  bottom: "3.5rem",
                  justifyContent: "space-between"

                }}

              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: isMydeSelfieModal ? "0px" : "45px",
                  }}
                >
                  <div
                    style={{
                      width: "180px",
                      height: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "25px",
                      fontSize: "18px"
                    }}
                  >
                    <button
                      onClick={handleOpenCamera}
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        backgroundColor: "#D6D5C9", // Color de fondo
                        color: "white", // Color del texto
                        border: "none", // Eliminar borde si es necesario
                        borderRadius: "8px",
                        marginBottom: "10px", // Opcional: esquinas redondeadas
                        minHeight: "110px"
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCamera}
                        style={{ fontSize: "70px" }}
                      />
                    </button>
                    <span style={{ color: "#777777" }}>
                      {T("checkin.use-camera")}
                    </span>
                  </div>
                  <div
                    style={{
                      width: "180px",
                      height: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "25px",
                      fontSize: "18px",
                    }}
                  >
                    <button
                      onClick={() => inputRef.current.click()}
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                        backgroundColor: "#D6D5C9",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        marginBottom: "10px",
                        minHeight: "110px"
                      }}
                      disabled={isMydeSelfieModal}
                    >
                      <FontAwesomeIcon icon={faFileUpload} style={{ fontSize: "70px", opacity: isMydeSelfieModal ? 0.4 : 1 }} />
                    </button>
                    <span style={{ color: "#777777", opacity: isMydeSelfieModal ? 0.3 : 1 }}>
                      {T("general.upload-file")}
                    </span>
                  </div>
                </div>

                {isMydeSelfieModal && (
                  <div className="d-flex align-items-center flex-column p-10">
                    <span className="text-danger font-weight-bold text-uppercase">{T("checkin.the_myde_selfie_message_title")}</span>
                    <span className="align-items-center p-3 text-center" style={{ fontSize: "12px", color: "#777777" }}>
                      {T("checkin.the_myde_selfie_message")}
                    </span>
                  </div>
                )}

                <input
                  type="file"
                  accept="image/*"
                  name="myImage"
                  ref={inputRef}
                  style={{ display: "none" }}
                  onChange={(event) => {
                    setImageFromDevice(event.target.files[0]);
                  }}
                />

                {/* Botón de Cancelar debajo de los otros botones */}
                <div style={{ width: "100%" }}>
                  <button
                    onClick={handleClose} // Función que cancela la operación
                    style={{
                      width: "100%", // Ocupar el ancho completo
                      padding: "10px",
                      fontSize: "14px",
                      backgroundColor: "#FF6B6B", // Fondo rojo
                      color: "white", // Texto blanco
                      border: "none",
                      borderRadius: "8px", // Opcional: esquinas redondeadas
                    }}
                  >
                    {T("general.cancel")} {/* Texto de Cancelar */}
                  </button>
                </div>
              </div>
            </>



          ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative", bottom: "3.5rem" }}>
              <div
                style={{
                  width: "200px",
                  height: "200px",
                  backgroundColor: "#D6D5C9",
                  backgroundImage: `url(${URL.createObjectURL(imageFromDevice)})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  borderRadius: "10px",
                  border: "2px solid #FFB74D",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.6)", // Sombra
                  marginBottom: "15px",
                }}
              ></div>

              <div style={{ display: "flex", justifyContent: "center", width: "100%", gap: "10px" }}>
                <Button
                  variant="danger" // Botón rojo para cancelar
                  onClick={() => setImageFromDevice(null)}
                  style={{ fontSize: "14px", padding: "5px 10px", width: "100px" }} // Ajustar tamaño
                >
                  {T("general.remove")}
                </Button>
                <Button
                  variant="success" // Botón verde para subir
                  onClick={handleUploadPhotoFromDevice}
                  style={{ fontSize: "14px", padding: "5px 10px", width: "100px" }} // Ajustar tamaño

                >
                  {T("general.upload")}
                </Button>
              </div>
            </div>


          )}
        </Modal.Body>
      </Modal>

    );
  };


  const [errors, setErrors] = useState({});

  const [validated, setValidated] = useState(false);





  const years = range(1930, getYear(new Date(new Date().setFullYear(new Date().getFullYear() + 15))), 1);

  const currentYear = getYear(new Date());
  const maxYear = idx <= 0 ? currentYear - 18 : currentYear;
  const birthYears = range(1930, maxYear, 1);

  const months = [
    T("date.january"),
    T("date.february"),
    T("date.march"),
    T("date.april"),
    T("date.may"),
    T("date.june"),
    T("date.july"),
    T("date.august"),
    T("date.september"),
    T("date.october"),
    T("date.november"),
    T("date.december"),
  ];


  useEffect(() => {
    const datePickers = document.getElementsByClassName("react-datepicker__input-container");
    Array.from(datePickers).forEach((el => el.childNodes[0].setAttribute("readOnly", true)))
    const _data = { ...passengers[idx] };
    const _reservation = JSON.parse(_data?.reservation);
    _data.name = _data.name || _reservation?.firstName || null;
    _data.surname = _data.surname || _reservation?.lastName || null;

    if (!_data.dniType && _reservation?.identificationType) {
      switch (_reservation.identificationType) {
        case "IdNumber":
          _data.dniType = "DNI";
          break;
        case "PassportNumber":
          _data.dniType = "PASSPORT";
          break;

        default:
          break;
      }
    }
    _data.dni = _data.dni || _reservation?.identificationNumber || null;
    _data.dniIssueDate = _data.dniIssueDate || _reservation?.identificationIssueDate || null;
    _data.dniIssueDate = _data.dniIssueDate ? _data.dniIssueDate : null;
    if (_data.dniIssueDate && typeof _data.dniIssueDate === "string") {
      _data.dniIssueDate = parseISO(_data.dniIssueDate);
    }

    if (_data.dniIssueDate && !(_data.dniIssueDate instanceof Date)) {
      _data.dniIssueDate = null;
    }

    _data.nationality =
      _data.nationality || _reservation?.nationalityCountryCode || null;

    _data.gender = normalizePassengerGender(_data.gender || _reservation?.gender) || null;

    _data.birthday = _data.birthday || _reservation?.birthDate || null;
    _data.birthday = _data.birthday ? _data.birthday : null;
    if (_data.birthday && typeof _data.birthday === "string") {
      _data.birthday = parseISO(_data.birthday);
    }
    if (_data.birthday && !(_data.birthday instanceof Date)) {
      _data.birthday = null;
    }

    _data.address =
      _data.address || _reservation?.address?.addressLine1 || null;

    _data.zipCode = _data.zipCode || _reservation?.address?.postalCode || null;

    _data.residence =
      _data.residence || _reservation?.address?.countryCode || null;

    _data.city = _data.city || _reservation?.address?.city || null;


    if (_data.photos) {
      _data.photos.dniFront = _data.photos.dniFront || null;
    }



    delete _data.reservation;
    console.log('_values_to_save data', _data);
    setValues({ ...values, ..._data });
  }, []);

  const titles = useMemo(() => {
    return {
      title: T("checkin." + cameraMode + ".preview-title"), // "DNI Frente",
      desc: T("checkin." + cameraMode + ".preview-text"), // "Recorte la imagen para centrar bien su documento.",
    };

  }, [cameraMode]);



  const save = useCallback(() => {

    if (values.ommited) {
      if (linked_checkin_idx === undefined) {
        setPassengerData(idx, { ommited: true });
      } else {
        setPassengerLinkedCheckinData(linked_checkin_idx, idx, { ommited: true });
      }
    }

    const _values_to_save = {
      ...values,
      photos: {
        selfie: photoSelfie.value || null,
        dniFront: photoDniFront.value || null,
        dniBack: photoDniBack.value || null,
      },
    };

    _values_to_save.age = 0;
    if (_values_to_save?.birthday) {
      _values_to_save.age = calculateAge(_values_to_save.birthday);
    }

    const normalizedGender = normalizePassengerGender(_values_to_save.gender);
    if (normalizedGender == null) {
      delete _values_to_save.gender;
    } else {
      _values_to_save.gender = normalizedGender;
    }

    setErrors({});
    if (_values_to_save.ommited) {
      _values_to_save.birthday = null;
      _values_to_save.dniIssueDate = null;
      if (linked_checkin_idx === undefined) {
        setPassengerData(idx, _values_to_save);
      } else {
        setPassengerLinkedCheckinData(linked_checkin_idx, idx, _values_to_save);
      }
      setValues(null);
      navigate(-1);
    }
    // chekinPersonSchema
    getValidations(hotel.id, showImages)
      .validate({ ..._values_to_save }, { context: { hotelId: hotel.id, idx: parseInt(idx, 10) }, abortEarly: false })
      .then(function () {
        _values_to_save.birthday = formatDate(_values_to_save.birthday);
        _values_to_save.dniIssueDate = _values_to_save.dniIssueDate ? formatDate(_values_to_save.dniIssueDate) : null;
        if (linked_checkin_idx === undefined) {
          setPassengerData(idx, _values_to_save);
        } else {
          setPassengerLinkedCheckinData(linked_checkin_idx, idx, _values_to_save);
        }
        setValues(null);
        navigate(-1);
      })
      .catch(function (err) {
        const validationErrors = {};
        err.inner?.forEach((error) => {
          if (error.path) {
            validationErrors[error.path.replace(".", "_")] = error.message;
          }
        });
        setErrors(validationErrors);
      });
  }, [values, photoSelfie, photoDniFront, photoDniBack]);

  if (!values) return <p>Loading...</p>;
  if (cameraMode)
    return (
      <CameraCropper
        type={cameraMode}
        title={titles.title}
        desc={titles.desc}
        onPhotoComplete={(dataUrl) => {
          const setter = setterMode[cameraMode];

          if (setter) {
            setter({ uploading: true, value: null });
          }
          setCameraMode(false);

          const fileName =
            checkIn.id +
            "_" +
            cameraMode +
            "_" +
            idx +
            "_" +
            Date.now() +
            ".jpg";

          resizeImage(dataURLtoBlob(dataUrl))
            .then((resizedBlob) => {
              return Storage.put(fileName, resizedBlob);
            })
            .then((res) => {
              if (res && res.key !== undefined) {
                if (setter) {
                  setter({ uploading: false, value: res.key });
                }
              }
            })
            .catch((error) => {
              console.error("Error uploading resized image:", error);
              if (setter) {
                setter({ uploading: false, value: null });
              }
            });
        }}
        onClose={() => {
          setCameraMode(false);
        }}
      />


    );

  const ReadonlyInput = ({ value, onClick, placeholder, id, is_invalid = "" }) => {
    const [fontSize, setFontSize] = useState('1rem');

    useEffect(() => {
      if (!value && id === "dniIssueDate" && placeholder[0].length > 10) {
        setFontSize('0.68rem');
      } else {
        setFontSize('0.80rem');
      }
    }, [id, placeholder]);

    return (
      <button
        className={`form-control ${isKioskMode ? "kiosk-datepicker-button" : "custom-datepicker-button"}  mb-0 ${is_invalid}`}
        type="button"
        onClick={onClick}
      >
        <>
          <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 5, fontSize }} />
          <span translate="no" className="mr-2" style={{ fontSize }}>
            {value || placeholder}
          </span>
        </>
      </button>
    );
  };

  const screenContent = (
    <Screen
      section={"checkin-passenger"}
      title={`${T("general.guest")} ${parseInt(idx) + 1}`}
      backUrl={`checkin?edit=true`}
      showBackButton={isKioskMode ? false : true}
    >
      <Form noValidate className={`${!photoDNIFrontRequired ? "hide-dni-front-required" : ""} pax-${idx}`}>
        <div className={`checkin-userform ${isKioskMode ? "kiosk-modern-form" : "mb-2 mt-2"}`}>
          {!values.ommited && (
            <>
              {/* DOCUMENT INFO */}
              {isKioskMode && <h6 className={`section-title ${classDocumentRow}`}>{T("checkin.document-info")}</h6>}
              <Form.Row className={classDocumentRow}>
                <Col xs={isKioskMode ? 12 : dniInformationColumnWidth} md={dniInformationColumnWidth} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }}>{T("checkin.inputs.dniType")} {idx <= 0 && !errors.dniType && !values.dniType && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      as={"select"}
                      placeholder={"Tipo de Documento"}
                      onChange={(event) => {
                        setValues({ ...values, dniType: event.target.value });
                        setErrors((prevState) => ({
                          ...prevState,
                          dniType: null,
                        }));
                      }}
                      isInvalid={errors.dniType}
                      isValid={validated && !errors.dniType}
                    >
                      <option
                        value=""
                        selected={values.dniType === "" ? "selected" : ""}
                      >
                        {T("checkin.inputs.dniType")}
                      </option>
                      <option
                        value="DNI"
                        selected={values.dniType === "DNI" ? "selected" : ""}
                      >
                        {T("checkin.id-type.id")}
                      </option>
                      <option
                        value="PASSPORT"
                        selected={
                          values.dniType === "PASSPORT" ? "selected" : ""
                        }
                      >
                        {T("checkin.id-type.passport")}
                      </option>
                    </Form.Control>
                    {errors.dniType && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.dniType)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                <Col xs={isKioskMode ? 12 : dniInformationColumnWidth} md={dniInformationColumnWidth} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{dniNumber} {idx <= 0 && !errors.dni && !values.dni && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"text"}
                      maxLength={12}
                      placeholder={dniNumber}
                      value={values.dni}
                      onChange={(event) => {
                        setValues({ ...values, dni: event.target.value });
                        setErrors((prevState) => ({ ...prevState, dni: null }));
                      }}
                      isInvalid={errors.dni}
                      isValid={validated && !errors.dni}
                    />
                    {errors.dni && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.dni)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                {showDniIssueDate && 
                <Col xs={isKioskMode ? 12 : 4} md={isKioskMode ? 4 : 4} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{dniIssueDate} {idx <= 0 && !errors.dniIssueDate && !values.dniIssueDate && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <DatePicker
                      id="dniIssueDate"
                      locale={currentLanguage}
                      popperClassName="rmdp-popper"
                      customInput={
                        <ReadonlyInput is_invalid={errors?.dniIssueDate ? "is-invalid" : ""} />
                      }
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth
                      }) => (
                        <div
                          style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <select
                            value={getYear(date)}
                            onChange={({ target: { value } }) => {
                              changeYear(value)
                            }}
                            className="form-control mr-1"
                            style={{ width: 70 }}
                          >
                            {years.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>

                          <select
                            value={getMonth(date)}
                            onChange={({ target: { value } }) => {
                              changeMonth(value)
                            }}
                            className="form-control"
                          >
                            {months.map((option, idx) => (
                              <option key={option} value={idx}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                      className={`form-control mb-0 ${errors.dniIssueDate ? "is-invalid" : ""}`}
                      selected={values.dniIssueDate instanceof Date ? values.dniIssueDate : null}
                      placeholderText={dniIssueDate}
                      dateFormat="dd MMM yyyy"
                      onChange={(date) => {
                        setValues({
                          ...values,
                          dniIssueDate: date
                        });
                        setErrors((prevState) => ({
                          ...prevState,
                          dniIssueDate: null,
                        }));
                      }}
                    />
                    <div className={`${errors.dniIssueDate ? "is-invalid" : ""}`}></div>
                    {errors.dniIssueDate && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.dniIssueDate)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>
                }
              </Form.Row>
              {/* END DOCUMENT INFO */}

              {/* PERSONAL INFO */}
              {isKioskMode && <h6 className="section-title">{T("checkin.personal-info")}</h6>}
              <Form.Row>
                <Col xs={isKioskMode ? 12 : 12} md={isKioskMode ? 6 : 12} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.name")} {(isApartYou(hotel.id) || idx <= 0) && !errors.name && !values.name && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"input"}
                      maxLength={50}
                      autoComplete="given-name"
                      placeholder={T("checkin.inputs.name")}
                      value={values.name}
                      onChange={(event) => {
                        setValues({ ...values, name: event.target.value });
                        setErrors((prevState) => ({ ...prevState, name: null }));
                      }}
                      isInvalid={errors.name}
                      isValid={validated && !errors.name}
                    />
                    {errors.name && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.name)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                <Col xs={isKioskMode ? 12 : 12} md={isKioskMode ? 6 : 12} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.surname")} {(isApartYou(hotel.id) || idx <= 0) && !errors.surname && !values.surname && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"input"}
                      maxLength={50}
                      autoComplete="family-name"
                      placeholder={T("checkin.inputs.surname")}
                      value={values.surname}
                      onChange={(event) => {
                        setValues({ ...values, surname: event.target.value });
                        setErrors((prevState) => ({ ...prevState, surname: null }));
                      }}
                      isInvalid={errors.surname}
                      isValid={validated && !errors.surname}
                    />
                    {errors.surname && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.surname)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                <Col xs={isKioskMode ? 12 : 12} md={isKioskMode ? 6 : 12} className={`${classEmail} ${isKioskMode ? "mb-3" : ""}`}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.email")} {idx > 0 && !errors.email && !values.email && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"input"}
                      maxLength={50}
                      placeholder={T("checkin.inputs.email")}
                      value={values.email}
                      onChange={(event) => {
                        setValues({ ...values, email: event.target.value });
                        setErrors((prevState) => ({ ...prevState, email: null }));
                      }}
                      isInvalid={errors.email}
                      isValid={validated && !errors.email}
                    />
                    {errors.email && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.email)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                <Col xs={isKioskMode ? 12 : 12} md={isKioskMode ? 6 : genderColumnWidth} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.nationality")} {idx <= 0 && !errors.nationality && !values.nationality && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      as={"select"}
                      autoComplete="country"
                      placeholder={`${T("checkin.inputs.nationality")}...`}
                      onChange={(event) => {
                        setValues({
                          ...values,
                          nationality: event.target.value,
                        });
                        setErrors((prevState) => ({
                          ...prevState,
                          nationality: null,
                        }));
                      }}
                      isInvalid={errors.nationality}
                      isValid={validated && !errors.nationality}
                    >
                      <option
                        value=""
                        selected={values.nationality === "" ? "selected" : ""}
                      >
                        {`${T("checkin.inputs.nationality")}...`}
                      </option>
                      {Object.values(sortedCountries).map((val, idx) => {
                        return (
                          <option
                            value={val.code}
                            key={idx}
                            selected={
                              values.nationality === val.code ? "selected" : ""
                            }
                          >
                            {val.name}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {errors.nationality && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.nationality)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                {showGender && 
                <Col xs={isKioskMode ? 12 : 6} md={isKioskMode ? 6 : 6} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.gender")} {idx <= 0 && !errors.gender && !values.gender && !isHostz(hotel.id) && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      as={"select"}
                      placeholder={T("checkin.inputs.gender")}
                      autoComplete="sex"
                      value={values.gender || ""}
                      onChange={(event) => {
                        setValues({ ...values, gender: event.target.value });
                        setErrors((prevState) => ({
                          ...prevState,
                          gender: null,
                        }));
                      }}
                      isInvalid={errors.gender}
                      isValid={validated && !errors.gender}
                    >
                      <option
                        value=""
                        selected={values.gender === "" ? "selected" : ""}
                      >
                        {T("checkin.inputs.gender")}
                      </option>
                      <option
                        value="male"
                        selected={values.gender === "male" ? "selected" : ""}
                      >
                        {T("checkin.inputs.gender.male")}
                      </option>
                      <option
                        value="female"
                        selected={values.gender === "female" ? "selected" : ""}
                      >
                        {T("checkin.inputs.gender.female")}
                      </option>
                      <option
                        value="other"
                        selected={values.gender === "other" ? "selected" : ""}
                      >
                        {T("checkin.inputs.gender.other")}
                      </option>
                    </Form.Control>
                    {errors.gender && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.gender)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>
                }

                <Col xs={isKioskMode ? 12 : 6} md={isKioskMode ? 6 : 6} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.date-of-birth")} {(isApartYou(hotel.id) || idx <= 0) && !errors.birthday && !values.birthday && !errors.ages && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                      <DatePicker
                        customInput={
                          <ReadonlyInput is_invalid={errors?.birthday ? "is-invalid" : ""} />
                        }
                        openToDate={new Date(new Date().setFullYear(new Date().getFullYear() - 30, 0, 1))}
                        locale={currentLanguage}
                        maxDate={idx <= 0 ? new Date(new Date().setFullYear(new Date().getFullYear() - 18)) : new Date()}
                        popperClassName="rmdp-popper"
                        renderCustomHeader={({
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled,
                        }) => (
                          <div
                            style={{
                              margin: 10,
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <select
                              value={getYear(date)}
                              onChange={({ target: { value } }) => {
                                changeYear(value)
                              }}
                              className="form-control mr-1"
                              style={{ width: 70 }}
                            >
                              {birthYears.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>

                            <select
                              value={getMonth(date)}
                              onChange={({ target: { value } }) => {
                                changeMonth(value)
                              }}
                              className="form-control"
                            >
                              {months.map((option, idx) => (
                                <option key={option} value={idx}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        // showYearDropdown
                        // scrollableYearDropdown={true}
                        // yearDropdownItemNumber={0}
                        className={`form-control mb-0 ${errors.birthday ? "is-invalid" : ""}`}
                        selected={values.birthday instanceof Date ? values.birthday : null}
                        placeholderText={T("checkin.inputs.date-of-birth")}
                        // openToDate={new Date("01-12-2000")}
                        dateFormat="dd MMM yyyy"
                        // dateFormat="yyyy/MM/dd"
                        onChange={(date) => {
                          // const _date_db = formatDate(date);
                          // console.log('1306 - _date_db', _date_db)
                          setValues({
                            ...values,
                            birthday: date
                          });
                          setErrors((prevState) => ({
                            ...prevState,
                            birthday: null,
                          }));
                        }}
                      />
                      <div className={`${errors.birthday ? "is-invalid" : ""}`}></div>
                      {errors.birthday && (
                        <Form.Control.Feedback type="invalid">
                          {T(errors.birthday)}
                        </Form.Control.Feedback>
                      )}
                      {!errors.birthday && errors.age && (
                        <Form.Control.Feedback type="invalid">
                          {T(errors.age)}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                </Col>
              </Form.Row>
              {/* END PERSONAL INFO */}
              {isKioskMode && <h6 className={`section-title ${classLocationRow}`}>{T("checkin.location")}</h6>}
              <Form.Row className={classLocationRow}>
              <Col className={`${classAddressCode} ${isKioskMode ? "mb-3" : ""}`} xs={isKioskMode ? 12 : 6} md={isKioskMode ? 6 : 6}>
                    <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.address")} {idx <= 0 && !errors.address && !values.address && isKioskMode && <span className="text-danger">*</span>}</label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={"input"}
                        maxLength={50}
                        placeholder={T("checkin.inputs.address") + '...'}
                        value={values.address}
                        onChange={(event) => {
                          setValues({ ...values, address: event.target.value });
                          setErrors((prevState) => ({
                            ...prevState,
                            address: null,
                          }));
                        }}
                        isInvalid={errors.address}
                        isValid={validated && !errors.address}
                      />
                      {errors.address && (
                        <Form.Control.Feedback type="invalid">
                          {T(errors.address)}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                </Col>

                <Col className={`${classZipCode} ${isKioskMode ? "mb-3" : ""}`} xs={isKioskMode ? 12 : 6} md={6}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.postal-code")} {idx <= 0 && !errors.zipCode && !values.zipCode && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"input"}
                      maxLength={50}
                      placeholder={`${T("checkin.inputs.postal-code")}...`}
                      value={values.zipCode}
                      onChange={(event) => {
                        setValues({ ...values, zipCode: event.target.value });
                        setErrors((prevState) => ({
                          ...prevState,
                          zipCode: null,
                        }));
                      }}
                      isInvalid={errors.zipCode}
                      isValid={validated && !errors.zipCode}
                    />
                    {errors.zipCode && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.zipCode)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>
                </Form.Row>
              {/* LOCATION */}
              
              <Form.Row className={`${classRowCity}`}>
                <Col xs={isKioskMode ? 12 : 6} md={6} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{isHostz(hotel.id) ? T("checkin.inputs.country_of_residence") : T("checkin.inputs.residence")} {idx <= 0 && !errors.residence && !values.residence && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      as={"select"}
                      placeholder={`${T(isHostz(hotel.id) ? "checkin.inputs.country_of_residence" : "checkin.inputs.residence")}...`}
                      onChange={(event) => {
                        setValues({
                          ...values,
                          residence: event.target.value,
                        });
                        setErrors((prevState) => {
                          return { ...prevState, residence: null };
                        });
                      }}
                      isInvalid={errors.residence}
                      isValid={validated && !errors.residence}
                    >
                      <option
                        value=""
                        selected={values.residence === "" ? "selected" : ""}
                      >
                        {`${T(isHostz(hotel.id) ? "checkin.inputs.country_of_residence" : "checkin.inputs.residence")}...`}
                      </option>
                      {Object.values(sortedCountries).map((val, idx) => {
                        return (
                          <option
                            value={val.code}
                            key={idx}
                            selected={
                              values.residence === val.code ? "selected" : ""
                            }
                          >
                            {val.name}
                          </option>
                        );
                      })}
                    </Form.Control>
                    {errors.residence && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.residence)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>

                <Col xs={isKioskMode ? 12 : 6} md={6} className={isKioskMode ? "mb-3" : ""}>
                  <label className="kiosk-label" style={{ display: "none" }} >{T("checkin.inputs.city")} {hotel.id === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516" && idx <= 0 && !errors.city && !values.city && isKioskMode && <span className="text-danger">*</span>}</label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={"input"}
                      maxLength={50}
                      placeholder={`${T("checkin.inputs.city")}...`}
                      value={values.city}
                      onChange={(event) => {
                        setValues({ ...values, city: event.target.value });
                        setErrors((prevState) => ({
                          ...prevState,
                          city: null,
                        }));
                      }}
                      isInvalid={errors.city}
                      isValid={validated && !errors.city}
                    />
                    {errors.city && (
                      <Form.Control.Feedback type="invalid">
                        {T(errors.city)}
                      </Form.Control.Feedback>
                    )}
                  </InputGroup>
                </Col>
              </Form.Row>
              {/* END LOCATION */}

              <p className="text-center font-size-sm mt-3 text-danger"> <span className="text-danger">(*)</span> {T("general.fields_required")}</p>
             {/* IMAGES */}
              {showImages && <>
                <Form.Row md={6} xs={12} className="mt-4">
                  <p className="font-size-sm text-center">
                    {T("checkin.request-photos")}
                  </p>
                </Form.Row>
                <Form.Row style={{ marginBottom: 25 }}>

                  <Col xs={4} style={{ display: showSelfie ? "block" : "none" }} className="selfieColumn" >
                    <h6
                      className="font-size-sm"
                      style={{
                        color: "#c77f47",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        textAlign: "center",
                      }}
                    >
                      Selfie
                      {(isHostzMyde(hotel.id) && idx == 0 || isRoyal(hotel?.id)) && idx == 0 && (
                        <span className="text-danger ml-1">*</span>
                      )}
                    </h6>
                    <div className="checkin-passenger-image">
                      {photoSelfie.uploading && (
                        <div className="loading">
                          <div className="spinner-border" role="status"></div>
                        </div>
                      )}
                      {!photoSelfie.uploading && !photoSelfie.value && (
                        <label
                          className=""
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title={T("general.edit")}
                        >
                          <button
                            type="button"
                            className="d-block border-0 w-100"
                            disabled={photoDniFront.uploading || photoDniBack.uploading}
                            onClick={() => {
                              setImageOriginModal(["selfie", "selfie"]);
                            }}
                          >
                            {/* <FontAwesomeIcon
                            size="lg"
                            icon={faCamera}
                            color="#666"
                            className="mr-1"
                          /> */}
                            <Selfie width={60} height={60} />
                          </button>
                        </label>
                      )}

                      {!photoSelfie.uploading && photoSelfie.value && (
                        <div
                          className="img-fluid h-100 border"
                          style={{
                            backgroundImage: `url(${getCDNImage(photoSelfie.value)})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      )}
                    </div>
                    {!photoSelfie.uploading && photoSelfie.value && (
                      <button
                        type="button"
                        className="text-center d-block font-size-sm border-0 w-100 text-danger bg-transparent"
                        disabled={photoDniFront.uploading || photoDniBack.uploading}
                        onClick={() => {
                          setImageOriginModal(["selfie", "selfie"]);
                        }}
                      >
                        {T("general.edit")}
                      </button>
                    )}
                    {errors && errors.photos_selfie && (
                      <span className="text-danger text-center small d-block mt-1">{T(`checkin.selfie.required`)}</span>
                    )}
                  </Col>

                  <Col xs={4} className={`dniFrontColumn`}>
                    <h6
                      className={`font-size-sm`}
                      style={{
                        color: "#c77f47",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        textAlign: "center",
                      }}
                    >
                      {T("checkin.dni-front")}
                        <span
                          className="dni-front-required-indicator text-danger ml-1"
                        >
                          *
                        </span>
                    </h6>
                    <div className="checkin-passenger-image">
                      {photoDniFront.uploading && (
                        <div className="loading">
                          <div className="spinner-border" role="status"></div>
                        </div>
                      )}
                      {!photoDniFront.uploading && !photoDniFront.value && (
                        <label
                          className=""
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title={T("general.edit")}
                        >
                          <button
                            type="button"
                            disabled={photoSelfie.uploading || photoDniBack.uploading}
                            className="d-block border-0 w-100"
                            onClick={() => {
                              setImageOriginModal([
                                "dniFront",
                                "checkin.dni-front",
                              ]);
                            }}
                          >



                            <IDFront width={75} height={75} />

                          </button>
                        </label>
                      )}
                      {!photoDniFront.uploading && photoDniFront.value && (
                        <div
                          className="img-fluid h-100 border"
                          style={{
                            backgroundImage: `url(${getCDNImage(photoDniFront.value)})`,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",

                            width: "100%",
                            height: "100%",

                          }}
                        />
                      )}
                    </div>
                    {!photoDniFront.uploading && photoDniFront.value && (
                      <button
                        type="button"
                        className="text-center d-block font-size-sm border-0 w-100 text-danger bg-transparent"
                        disabled={photoSelfie.uploading || photoDniBack.uploading}
                        onClick={() => {
                          setImageOriginModal(["dniFront", "checkin.dni-front"]);
                        }}
                      >
                        {T("general.edit")}
                      </button>
                    )}


                    {errors && errors.photos_dniFront && (
                      <span className="text-danger text-center small d-block mt-1">{T(`checkin.dniFront.required`)}</span>
                    )}
                  </Col>

                  <Col xs={4} className="dniBackColumn">
                    <h6
                      className="font-size-sm"
                      style={{
                        color: "#c77f47",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        textAlign: "center",
                      }}
                    >
                      {T("checkin.dni-back")}
                      {(isHostzMyde(hotel.id) || isRoyal(hotel?.id)) && (
                        <span className="text-danger ml-1">*</span>
                      )}
                    </h6>
                    <div className="checkin-passenger-image">
                      {photoDniBack.uploading && (
                        <div className="loading">
                          <div className="spinner-border" role="status"></div>
                        </div>
                      )}
                      {!photoDniBack.uploading && !photoDniBack.value && (
                        <label
                          className="mb-0"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title={T("general.edit")}
                        >
                          <button
                            type="button"
                            disabled={photoSelfie.uploading || photoDniFront.uploading}
                            className="d-block border-0 w-100"
                            onClick={() => {
                              setImageOriginModal([
                                "dniBack",
                                "checkin.dni-back",
                              ]);
                            }}
                          >
                            {/* <FontAwesomeIcon
                            size="lg"
                            icon={faCamera}
                            color="#666"
                            className="mr-1"
                          /> */}
                            <IDBack width={75} height={75} />
                          </button>
                        </label>
                      )}
                      {!photoDniBack.uploading && photoDniBack.value && (
                        <div
                          className="img-fluid h-100 border"
                          style={{
                            backgroundImage: `url(${getCDNImage(photoDniBack.value)})`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      )}
                    </div>
                    {!photoDniBack.uploading && photoDniBack.value && (
                      <button
                        type="button"
                        className="text-center d-block font-size-sm border-0 w-100 text-danger bg-transparent"
                        disabled={photoSelfie.uploading || photoDniFront.uploading}
                        onClick={() => {
                          setImageOriginModal(["dniBack", "checkin.dni-back"]);
                        }}
                      >
                        {T("general.edit")}
                      </button>
                    )}

                    {errors && errors.photos_dniBack && (
                      <span className="text-danger text-center small d-block mt-1">{T(`checkin.dniBack.required`)}</span>
                    )}
                  </Col>
                </Form.Row></>}
              {/* END IMAGES */}
            </>
          )}

          <div
            className={`${/*qtyPassenger*/ 1 > 0 ? (isKioskMode ? 'kiosk-checkin-footer-container container pr-0 pl-0' : 'footer-container') : ""}`}
          >
            {errors && Object.keys(errors).length > 0 && <ErrorMessages errors={errors} width="100%" isOffgrid={isOffgrid(hotel?.id)} />}
            <Row className={`${isKioskMode ? 'w-100' : ''}`}>
              <Col xs={6} className={`${isKioskMode ? 'pl-0' : ''}`}>
                <Button
                  className={"w-100"}
                  size={"md"}
                  variant={"secondary"}
                  style={{ textTransform: "uppercase" }}
                  type={"button"}
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {T("general.cancel")}
                </Button>
              </Col>
              <Col xs={6} className={`${isKioskMode ? 'pr-0' : ''}`}>
                <Button
                  size={"md"}
                  className={"w-100"}
                  style={{
                    marginBottom: 12,
                    marginRight: 20,
                  }}
                  variant={isKioskMode ? `secondary` : `primary`}
                  type={"button"}
                  disabled={photoSelfie.uploading || photoDniFront.uploading || photoDniBack.uploading}
                  onClick={save}
                >
                  {T("general.save")}
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Form>
      <ImageOriginModal />
    </Screen >
  );
  
  // Envolver en kiosk wrapper si está en modo kiosk
  if (isKioskMode) {
    return (
      <div className="kiosk-checkin-wrapper">
        <div className="kiosk-checkin-container container">
          {screenContent}
        </div>
      </div>
    );
  }
  
  return screenContent;
};

export default CheckInPassenger;
